import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { Modal } from 'react-bootstrap';
import { withRouter } from "react-router-dom";
import _ from 'lodash';

import config from 'react-global-configuration';
import moment from 'moment'

import ResidenceConfirmBooking from './ResidenceConfirmBooking'
import ResidenceBookingSuccess from './ResidenceBookingSuccess'
import ResidenceBookingError from './ResidenceBookingError'

import { ImageSection, ModalHeading } from '../../../GeneralStyle'

@inject('residenceBookingStore')

@observer
class ResidenceBookingModal extends Component {


  constructor(props) {
    super(props)
    this.state = {
      showModal: this.props.showModal,
      showAlert: true
    }

    this.closeModal = this.closeModal.bind(this)
  }

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  openModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false })
    this.props.residenceBookingStore.setDate(null)
    this.props.residenceBookingStore.setScreenNumber(1)
  }

  render() {


    const {
      screenNumber,
      bookingDate,
      // bookingSuccess
    } = this.props.residenceBookingStore

    const modalSize = "md"
    return (
      <div>
        <Modal  show={this.state.showModal} onHide={this.closeModal} bsSize={modalSize}>
          <ImageSection style={{backgroundImage: 'linear-gradient(45deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.6) 100%), url('+ config.get('CLOUDINARY_URL') + "c_scale,q_60,w_1593/v1556735108/residence_plpeyf.jpg)"}} background={config.get('CLOUDINARY_URL') + "c_scale,q_60,w_1593/v1556735108/residence_plpeyf.jpg"}>
            <Modal.Header closeButton>
              <Modal.Title style={{height: '100%', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                <div>
                  <ModalHeading style={{margin: 0}}>
                    Ihre Buchung von {moment(bookingDate).format('DD.MM')} bis {moment(bookingDate).add(7, 'day').format('DD.MM')} in Marbella
                    </ModalHeading>
                </div>
              </Modal.Title>
            </Modal.Header>
          </ImageSection>
          <Modal.Body style={{ paddingTop: 0 }}>

                {screenNumber === 2
                  && <ResidenceConfirmBooking closeModal={this.closeModal} />}

              {(screenNumber === 3)
              && <ResidenceBookingSuccess closeModal={this.closeModal} />}

              {screenNumber === 4
              && <ResidenceBookingError closeModal={this.closeModal} />}

          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

ResidenceBookingModal.propTypes = {
  residenceBookingStore: MobxPropTypes.observableObject
};

export default withRouter(ResidenceBookingModal);



// WEBPACK FOOTER //
// /src/components/internal/Residence/ResidenceBookingModal/ResidenceBookingModal.js